import { render, staticRenderFns } from "./FullScreenOverlay.vue?vue&type=template&id=60bf0703&scoped=true"
var script = {}
import style0 from "./FullScreenOverlay.vue?vue&type=style&index=0&id=60bf0703&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bf0703",
  null
  
)

export default component.exports